import {Button} from '@purpose/ui/components/button/button';
import {cn} from '@purpose/ui/lib/utils';
interface IBottomButtonsWithMobileGradient {
  className?: string;
  topButtonProps: {
    title?: string;
    isLoading?: boolean;
    onClick?: () => void;
    disabled?: boolean;
    type?: 'button' | 'reset' | 'submit';
    render?: () => React.ReactNode;
  };
  bottomButtonProps?: {
    title?: string;
    isLoading?: boolean;
    disabled?: boolean;

    onClick?: () => void;
    type?: 'button' | 'reset' | 'submit';
    render?: () => React.ReactNode;
  };
}
const BottomButtonsWithMobileGradient = ({
  topButtonProps,
  className,
  bottomButtonProps
}: IBottomButtonsWithMobileGradient) => (
  <div
    className={cn(
      'flex w-full flex-col items-center gap-2 bg-gradient-to-b from-white/0 to-white px-1.5 py-5 [backdrop-filter:blur(0.5px)] sm:px-7 md:w-auto md:gap-1 md:px-0',
      className
    )}
    style={{
      background:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 90%)'
    }}
  >
    {topButtonProps?.render?.() || (
      <Button
        onClick={topButtonProps?.onClick}
        type={topButtonProps?.type}
        disabled={topButtonProps?.disabled || topButtonProps?.isLoading}
        className={`h-11 w-full rounded-full px-4.5 md:w-auto`}
        aria-label={topButtonProps?.title}
      >
        {topButtonProps?.isLoading ? (
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
        ) : (
          topButtonProps?.title
        )}
      </Button>
    )}
    {bottomButtonProps &&
      (bottomButtonProps?.render?.() || (
        <Button
          variant="ghost"
          isLoading={bottomButtonProps.isLoading}
          className={`h-11 w-full rounded-full px-4.5 md:w-auto`}
          disabled={bottomButtonProps.disabled}
          {...(bottomButtonProps.onClick && {
            onClick: bottomButtonProps.onClick
          })}
          {...(bottomButtonProps.type && {type: bottomButtonProps.type})}
          aria-label={bottomButtonProps?.title}
        >
          {bottomButtonProps?.title}
        </Button>
      ))}
  </div>
);

export default BottomButtonsWithMobileGradient;
